import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/notaDePedido/OrdenDeVenta`;
const readUrl = (url = "") => `${urlBase}${url}`;
// const urlBaseAdecco = `${process.env.API_URL}/notaDePedido/Adecco/OrdenDeVenta`;
// const readUrlAdecco = (url = "") => `${urlBaseAdecco}${url}`;

export const getOrdenesDeVentaById = async (id) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${id}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const createOrdenDeVenta = async (body) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(``), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  res = await parseJSON(res);

  return res.success;
};

export const updateOrdenDeVenta = async (id, body) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  res = await parseJSON(res);

  return res.success;
};

// para export de ordenes de venta
export const exportOrdenesDeVenta = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  const res = await fetch(readUrl(`/export?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  const blob = await res.blob();
  return blob;
};

// export const getOrdenDeVentaAdecco = async (params) => {
//   const auth = `Bearer ${getToken()}`;
//   const query = new URLSearchParams(params);

//   let res = await fetch(readUrlAdecco(`?${query}`), {
//     method: "GET",
//     headers: {
//       Accept: "application/json",
//       Authorization: auth,
//       "Content-Type": "application/json",
//     },
//   });

//   res = await parseJSON(res);
//   return res.success;
// };

// export const updateOrdenDeVentaAdecco = async (id, body) => {
//   const auth = `Bearer ${getToken()}`;

//   let res = await fetch(readUrlAdecco(`/${id}`), {
//     method: "PATCH",
//     headers: {
//       Accept: "application/json",
//       Authorization: auth,
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(body),
//   });

//   res = await parseJSON(res);

//   return res.success;
// };
